import pgSwitch from './pgSwitch.vue'
export default pgSwitch
